/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import { base as i, animationStyles as e, containers as s, states as u, popup as l, directionMap as f } from "./json-classes.mjs";
const d = {
  animationContainer: `${i.prefix}-${e.prefix}-${s.container}`,
  animationContainerShown: `${i.prefix}-${e.prefix}-${s.container}-${u.shown}`,
  animationChild: `${i.prefix}-${e.child}-${e.prefix}-${s.container}`,
  popup: `${i.prefix}-${l.prefix}`,
  slide: {
    up: {
      enter: `${i.prefix}-${e.slide}-${f.up}-${e.enter}`,
      exit: `${i.prefix}-${e.slide}-${f.up}-${e.exit}`
    },
    down: {
      enter: `${i.prefix}-${e.slide}-${f.down}-${e.enter}`,
      exit: `${i.prefix}-${e.slide}-${f.down}-${e.exit}`
    },
    left: {
      enter: `${i.prefix}-${e.slide}-${f.left}-${e.enter}`,
      exit: `${i.prefix}-${e.slide}-${f.left}-${e.exit}`
    },
    right: {
      enter: `${i.prefix}-${e.slide}-${f.right}-${e.enter}`,
      exit: `${i.prefix}-${e.slide}-${f.right}-${e.exit}`
    }
  },
  slideActive: {
    up: {
      enter: `${i.prefix}-${e.slide}-${f.up}-${e.enter}-${e.active}`,
      exit: `${i.prefix}-${e.slide}-${f.up}-${e.exit}-${e.active}`
    },
    down: {
      enter: `${i.prefix}-${e.slide}-${f.down}-${e.enter}-${e.active}`,
      exit: `${i.prefix}-${e.slide}-${f.down}-${e.exit}-${e.active}`
    },
    left: {
      enter: `${i.prefix}-${e.slide}-${f.left}-${e.enter}-${e.active}`,
      exit: `${i.prefix}-${e.slide}-${f.left}-${e.exit}-${e.active}`
    },
    right: {
      enter: `${i.prefix}-${e.slide}-${f.right}-${e.enter}-${e.active}`,
      exit: `${i.prefix}-${e.slide}-${f.right}-${e.exit}-${e.active}`
    }
  },
  zoom: {
    in: {
      enter: `${i.prefix}-${e.zoomIn}-${e.enter}`,
      exit: `${i.prefix}-${e.zoomIn}-${e.exit}`
    },
    out: {
      enter: `${i.prefix}-${e.zoomIn}-${e.enter}`,
      exit: `${i.prefix}-${e.zoomOut}-${e.exit}`
    }
  },
  zoomActive: {
    in: {
      enter: `${i.prefix}-${e.zoomIn}-${e.enter}-${e.active}`,
      exit: `${i.prefix}-${e.zoomIn}-${e.exit}-${e.active}`
    },
    out: {
      enter: `${i.prefix}-${e.zoomOut}-${e.enter}-${e.active}`,
      exit: `${i.prefix}-${e.zoomOut}-${e.exit}-${e.active}`
    }
  },
  fade: {
    enter: `${i.prefix}-${e.fade}-${e.enter}`,
    exit: `${i.prefix}-${e.fade}-${e.exit}`
  },
  fadeActive: {
    enter: `${i.prefix}-${e.fade}-${e.enter}-${e.active}`,
    exit: `${i.prefix}-${e.fade}-${e.exit}-${e.active}`
  },
  push: {
    up: {
      enter: `${i.prefix}-${e.pushUp}-${e.enter}`,
      exit: `${i.prefix}-${e.pushUp}-${e.exit}`
    },
    down: {
      enter: `${i.prefix}-${e.pushDown}-${e.enter}`,
      exit: `${i.prefix}-${e.pushDown}-${e.exit}`
    },
    left: {
      enter: `${i.prefix}-${e.pushLeft}-${e.enter}`,
      exit: `${i.prefix}-${e.pushLeft}-${e.exit}`
    },
    right: {
      enter: `${i.prefix}-${e.pushRight}-${e.enter}`,
      exit: `${i.prefix}-${e.pushRight}-${e.exit}`
    }
  },
  pushActive: {
    up: {
      enter: `${i.prefix}-${e.pushUp}-${e.enter}-${e.active}`,
      exit: `${i.prefix}-${e.pushUp}-${e.exit}-${e.active}`
    },
    down: {
      enter: `${i.prefix}-${e.pushDown}-${e.enter}-${e.active}`,
      exit: `${i.prefix}-${e.pushDown}-${e.exit}-${e.active}`
    },
    left: {
      enter: `${i.prefix}-${e.pushLeft}-${e.enter}-${e.active}`,
      exit: `${i.prefix}-${e.pushLeft}-${e.exit}-${e.active}`
    },
    right: {
      enter: `${i.prefix}-${e.pushRight}-${e.enter}-${e.active}`,
      exit: `${i.prefix}-${e.pushRight}-${e.exit}-${e.active}`
    }
  },
  expand: {
    horizontal: {
      enter: `${i.prefix}-${e.expandHorizontal}-${e.enter}`,
      exit: `${i.prefix}-${e.expandHorizontal}-${e.exit}`
    },
    vertical: {
      enter: `${i.prefix}-${e.expandVertical}-${e.enter}`,
      exit: `${i.prefix}-${e.expandVertical}-${e.exit}`
    }
  },
  expandActive: {
    horizontal: {
      enter: `${i.prefix}-${e.expandHorizontal}-${e.enter}-${e.active}`,
      exit: `${i.prefix}-${e.expandHorizontal}-${e.exit}-${e.active}`
    },
    vertical: {
      enter: `${i.prefix}-${e.expandVertical}-${e.enter}-${e.active}`,
      exit: `${i.prefix}-${e.expandVertical}-${e.exit}-${e.active}`
    }
  }
}, v = {
  animationContainer: (p) => {
    const { c: $ = d } = p;
    return {
      [$ == null ? void 0 : $.animationContainer]: !0
    };
  },
  animationContainerShown: (p) => {
    const { c: $ = d } = p;
    return {
      [$ == null ? void 0 : $.animationContainerShown]: !0
    };
  },
  animationChild: (p) => {
    const { c: $ = d } = p;
    return {
      [$ == null ? void 0 : $.animationChild]: !0
    };
  },
  popup: (p) => {
    const { c: $ = d } = p;
    return {
      [$ == null ? void 0 : $.popup]: !0
    };
  },
  slide: (p) => {
    var n, x, o, a;
    const { direction: $, type: r, c: t = d } = p;
    return {
      [(x = (n = t == null ? void 0 : t.slide) == null ? void 0 : n[$]) == null ? void 0 : x[r]]: (a = (o = t == null ? void 0 : t.slide) == null ? void 0 : o[$]) == null ? void 0 : a[r]
    };
  },
  slideActive: (p) => {
    var n, x, o, a;
    const { direction: $, type: r, c: t = d } = p;
    return {
      [(x = (n = t == null ? void 0 : t.slideActive) == null ? void 0 : n[$]) == null ? void 0 : x[r]]: (a = (o = t == null ? void 0 : t.slideActive) == null ? void 0 : o[$]) == null ? void 0 : a[r]
    };
  },
  zoom: (p) => {
    var n, x, o, a;
    const { direction: $, type: r, c: t = d } = p;
    return {
      [(x = (n = t == null ? void 0 : t.zoom) == null ? void 0 : n[$]) == null ? void 0 : x[r]]: (a = (o = t == null ? void 0 : t.zoom) == null ? void 0 : o[$]) == null ? void 0 : a[r]
    };
  },
  zoomActive: (p) => {
    var n, x, o, a;
    const { direction: $, type: r, c: t = d } = p;
    return {
      [(x = (n = t == null ? void 0 : t.zoomActive) == null ? void 0 : n[$]) == null ? void 0 : x[r]]: (a = (o = t == null ? void 0 : t.zoomActive) == null ? void 0 : o[$]) == null ? void 0 : a[r]
    };
  },
  fade: (p) => {
    var t, n;
    const { type: $, c: r = d } = p;
    return {
      [(t = r == null ? void 0 : r.fade) == null ? void 0 : t[$]]: (n = r == null ? void 0 : r.fade) == null ? void 0 : n[$]
    };
  },
  fadeActive: (p) => {
    var t, n;
    const { type: $, c: r = d } = p;
    return {
      [(t = r == null ? void 0 : r.fadeActive) == null ? void 0 : t[$]]: (n = r == null ? void 0 : r.fadeActive) == null ? void 0 : n[$]
    };
  },
  push: (p) => {
    var n, x, o, a;
    const { direction: $, type: r, c: t = d } = p;
    return {
      [(x = (n = t == null ? void 0 : t.push) == null ? void 0 : n[$]) == null ? void 0 : x[r]]: (a = (o = t == null ? void 0 : t.push) == null ? void 0 : o[$]) == null ? void 0 : a[r]
    };
  },
  pushActive: (p) => {
    var n, x, o, a;
    const { direction: $, type: r, c: t = d } = p;
    return {
      [(x = (n = t == null ? void 0 : t.pushActive) == null ? void 0 : n[$]) == null ? void 0 : x[r]]: (a = (o = t == null ? void 0 : t.pushActive) == null ? void 0 : o[$]) == null ? void 0 : a[r]
    };
  },
  expand: (p) => {
    var n, x, o, a;
    const { direction: $, type: r, c: t = d } = p;
    return {
      [(x = (n = t == null ? void 0 : t.expand) == null ? void 0 : n[$]) == null ? void 0 : x[r]]: (a = (o = t == null ? void 0 : t.expand) == null ? void 0 : o[$]) == null ? void 0 : a[r]
    };
  },
  expandActive: (p) => {
    var n, x, o, a;
    const { direction: $, type: r, c: t = d } = p;
    return {
      [(x = (n = t == null ? void 0 : t.expandActive) == null ? void 0 : n[$]) == null ? void 0 : x[r]]: (a = (o = t == null ? void 0 : t.expandActive) == null ? void 0 : o[$]) == null ? void 0 : a[r]
    };
  }
};
export {
  v as uPopup
};
